@if(context === 'addOtherFeedback'){
    <p class="text-secondary text-center pt-4 pb-3">
        @if(pollRequest?.poll.author){
            {{pollRequest.poll.author}} {{'add_other_feedback.poll.posted' | translate}}
            <span class="badge rounded-pill text-bg-light">{{pollRequest.team.name}}</span>
        }@else{
            {{'add_other_feedback.poll.posted_alt' | translate}}<span class="badge rounded-pill text-bg-light">{{pollRequest?.team.name}}</span>
        }
    </p>
}
<div class="position-relative" id="{{'item-' + pollRequest?.id}}">
    @switch (pollRequestStep){
        @case(1){
            <div [ngClass]="{'media card topic-card ': context === 'timeline', 'border rounded': context === 'addOtherFeedback'}"
                class="position-relative animate__animated animate__fadeIn" id="{{pollRequest.poll.id}}">

                <div class="card-top p-0">
                    <div class="pt-2 pe-2" [ngClass]="{'d-none': context === 'addOtherFeedback'}">
                        <i class="fa-light fa-clipboard-question fa-2x ms-2 pt-2 position-relative"></i>
                    </div>

                    @if(pollRequest?.poll.author){
                    <span class="badge rounded-pill text-bg-secondary mt-2 me-2 position-absolute top-0 end-0 fw-normal"
                        [ngClass]="{'d-none': context === 'addOtherFeedback'}">
                        <i>{{'poll_request.posted' | translate}} </i>{{pollRequest.poll.author}}
                    </span>
                    }

                    <div class="card-comment"
                        [ngClass]="{'p-3 my-2': context === 'timeline', 'p-4': context === 'addOtherFeedback'}">
                        @switch(pollRequest.poll?.type){
                            @case ('ClosedQuestion') {
                            <closed-question [question]="pollRequest.poll" (onAnswerChange)="postAnswer($event)"></closed-question>
                            }
                            @case ('AgreeDisagreeQuestion') {
                            <agree-disagree-question [question]="pollRequest.poll"
                                (onAnswerChange)="postAnswer($event)"></agree-disagree-question>
                            }
                            @case ('FiveStarsQuestion') {
                            <five-stars-question [question]="pollRequest.poll"
                                (onAnswerChange)="postAnswer($event)"></five-stars-question>
                            }
                            @case ('ScaleQuestion') {
                            <scale-question [question]="pollRequest.poll" (onAnswerChange)="postAnswer($event)"></scale-question>
                            }
                        }
                        <div class="d-flex justify-content-evenly alternative-answers pt-2">
                            @if(pollRequest.poll.dontWantToAnswerFeature){
                            <button (click)="postAnswer(pollRequest.poll.dontWantToAnswerFeature.id)"
                                data-cy="request-poll-not_want_to_answer-btn">
                                <i class="fa-light fa-comment-slash"></i>&nbsp;{{'poll_request.not_want_to_answer' | translate}}
                            </button>
                            }
                            <button (click)="askMeLater()">
                                <i class="fa-light fa-hourglass-clock"></i>&nbsp;{{'poll_request.skip' | translate}}
                            </button>
                        </div>
                    </div>
                    <!-- option placeholder-->
                    <div class="card-options" [ngClass]="{'d-none': context === 'addOtherFeedback'}"></div>
                </div>
                <p class="card-footer d-flex justify-content-between align-items-center bg-white position-absolute bottom-0 end-0">
                @if(remainingPollNb > 0){
                    <i [ngPlural]="remainingPollNb">
                        {{remainingPollNb}}
                        <ng-template ngPluralCase="=1">{{'poll_request.remaining_question' | translate}}</ng-template>
                        <ng-template ngPluralCase="other">{{'poll_request.remaining_questions' | translate}}</ng-template>
                    </i>
                }
                </p>
            </div>
        }
        @case(2){
            <div class="card w-100 p-0 my-2 question-sucess animate__animated animate__slideInTop"
                [ngClass]="{'': context === 'timeline', 'bg-white': context === 'addOtherFeedback'}">
                <form class="card-body m-0"
                    [ngClass]="{'bg-white rounded user-request': context === 'timeline', 'p-4': context === 'addOtherFeedback'}">
                    
                    <label id="commentLabel" for="poll-comment" class="fst-italic pb-3">
                        <i class="fa-regular fa-comment"></i>&nbsp;{{ 'poll.comment.title' | translate }}
                    </label>
        
                    <tm-rich-text-area [(content)]="rtaContent"
                                       [threadAuthors]="[]"
                                       (contentChange)="onContentChange($event)"
                                       [placeholderText]="'poll_comment_request.placeholder' | translate"/>

                    @if(linkPreviews?.length > 0){
                        <div class="previews-area">
                            <div>
                                @for(linkPreview of linkPreviews; track linkPreview){
                                    <tm-link-preview [linkPreview]="linkPreview"></tm-link-preview>
                                }
                            </div>
                        </div>
                    }

                    <p class="card-footer d-flex justify-content-end align-items-center bg-white gx-2 border-0 px-0 pb-0 pt-3">
                        <button class="btn btn-block btn-sm btn-primary me-2" (click)="postComment()" [disabled]="isFieldEmplty">
                            {{'poll_comment_request.post_comment' | translate}}
                        </button>
                        <button class="btn btn-block btn-secondary btn-sm" (click)="skipAddingComment()" data-cy="request-question-skip-comment-btn">
                            {{'poll_comment_request.skip' | translate}}
                        </button>
                    </p>
                </form>
            </div>
        }
    }
</div>